import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { createValidator } from 'functions/validation/zod';

const ProductSchema = z.object({
	priority: z.number(),
	productId: z.string(),
	sourceId: z.string(),
});

const OrderGuideSchema = z.object({
	id: z.string(),
	ingredientId: z.string(),
	products: z.array(ProductSchema),
});

const ResponseDataSchema = OrderGuideSchema;
const validator = createValidator(ResponseDataSchema);

export type ResponseData = z.infer<typeof ResponseDataSchema>;
export type Product = z.infer<typeof ProductSchema>;
export type RequestBody = Product[];

export async function callApi(
	ingredientId: string,
	requestBody: RequestBody
): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/erp/order-guide/${ingredientId}`;
	return (await axios.post(url, requestBody).toOptionalFiltered(validator)).map((x) => x.data);
}
